module.exports = __webpack_public_path__ + "img/Logo.3575835c.png";